import { RECEIVE_BUSINESS_VERIFICATION_DATA } from '../constants/actionTypes';

export function receiveBusinessVerificationData(data, userIdIrene) {
  return {
    type: RECEIVE_BUSINESS_VERIFICATION_DATA,
    data,
    userIdIrene,
  };
}
